// extracted by mini-css-extract-plugin
export var playersSetupContainer = "PlayersSetup-module--playersSetupContainer--_iYFM";
export var playersSetupTitle = "PlayersSetup-module--playersSetupTitle--1jomT";
export var playersContainer = "PlayersSetup-module--playersContainer--QyGQZ";
export var addPlayerButton = "PlayersSetup-module--addPlayerButton--1SPsy";
export var playersSetupSubmitButton = "PlayersSetup-module--playersSetupSubmitButton--JVxZu";